var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.role !== 'CLIENT')?_c('div',{staticClass:"watermark"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"ribbon text-center",class:_vm.status ? 'success' : 'error'},[_vm._v(" "+_vm._s(_vm.text)+" ")])])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }